import condition from './condition.vue'

export default condition
